module.exports = __webpack_public_path__ + "img/RW.955c8713.svg";